import { type IconProps } from '../iconProps';

export const Lightning: React.FC<IconProps> = ({ size, fill }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 30 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g filter='url(#filter0_d_139_223)'>
        <path
          d='M10.2312 20.8408H5.79645C5.11269 20.8408 4.60757 20.5362 4.28107 19.927C3.95482 19.3177 3.99057 18.7272 4.38832 18.1555L16.0493 1.37572C16.3173 1.00172 16.6647 0.743098 17.0914 0.599848C17.5184 0.456348 17.9534 0.465472 18.3964 0.627222C18.8392 0.789222 19.1711 1.06822 19.3921 1.46422C19.6131 1.86022 19.6956 2.2856 19.6396 2.74035L18.4126 12.6591H24.0278C24.7616 12.6591 25.2791 12.9855 25.5803 13.6382C25.8818 14.291 25.7931 14.9002 25.3141 15.466L12.5194 30.8237C12.2264 31.1727 11.8679 31.3972 11.4439 31.4972C11.0202 31.5972 10.6058 31.5567 10.2008 31.3757C9.79607 31.1947 9.48294 30.9111 9.26145 30.5248C9.03995 30.1383 8.9572 29.7206 9.0132 29.2716L10.2312 20.8408Z'
          fill={fill}
        />
      </g>
      <defs>
        <filter
          id='filter0_d_139_223'
          x='0.0605469'
          y='0.498657'
          width='29.6943'
          height='39.0519'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood
            floodOpacity='0'
            result='BackgroundImageFix'
          />
          <feColorMatrix
            in='SourceAlpha'
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
            result='hardAlpha'
          />
          <feOffset dy='4' />
          <feGaussianBlur stdDeviation='2' />
          <feComposite
            in2='hardAlpha'
            operator='out'
          />
          <feColorMatrix
            type='matrix'
            values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0'
          />
          <feBlend
            mode='normal'
            in2='BackgroundImageFix'
            result='effect1_dropShadow_139_223'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_dropShadow_139_223'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};
